import { COLORS, FONTS, SIZE } from '@app/src/ui';
import styled from 'styled-components';

const ROOT = 'MyPackage/listMyPackage/CardPackage';

export const Wrapper = styled.article`
  border: 1px solid #000;
  border-radius: 6px;
  background: #fff;
  font-family: ${FONTS.ROBOTO};
  font-size: 15px;
  color: ${COLORS.GRAY_DARK};
  min-height: 340px;
  padding: 20px 15px 23px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: flex;
    max-width: 100%;
    min-height: 100px;
    justify-content: space-around;
    align-items: center;
  }
`;

Wrapper.className = `${ROOT}/Wrapper`;

export const TitleWrapper = styled.div``;

TitleWrapper.className = `${ROOT}/TitleWrapper`;

export const TitleContent = styled.div`
  text-align: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: flex;
    align-items: center;
    flex: 0 0 210px;
    width: 210px;
    text-align: left;
  }
`;

TitleContent.className = `${ROOT}/TitleContent`;

export const IconExpandMore = styled.span`
  display: block;
  margin-top: 28px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 0 0 0 20px;
    svg {
      transform: rotate(-90deg);
    }
  }
`;

export const PackageName = styled.h2`
  font-size: 18px;
  color: ${COLORS.BLACK_BOLD};
`;

PackageName.className = `${ROOT}/PackageName`;

export const CategoryName = styled.span`
  font-size: 16px;
  color: ${COLORS.BLUE_LINK};
  margin-top: 6px;
`;

CategoryName.className = `${ROOT}/CategoryName`;

export const DescriptionContent = styled.div`
  display: flex;
  margin: 28px auto 0;
  flex: 0 0 295px;
  width: 295px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin-top: 0;
  }
`;

DescriptionContent.className = `${ROOT}/DescriptionContent`;

export const Announcement = styled.div`
  border-right: 1px solid ${COLORS.GRAY};
  flex: 0 0 50%;
  width: 50%;
  justify-content: flex-end;
  text-align: right;
  padding-right: 20px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    text-align: left;
    padding: 0 0 0 20px;
  }
`;

Announcement.className = `${ROOT}/Announcement`;

export const Legend = styled.p`
  color: #00B344;
  font-size: 13px;
  margin-bottom: 4px;
`;

Legend.className = `${ROOT}/Legend`;

export const CountAnnouncement = styled.p``;

CountAnnouncement.className = `${ROOT}/CountAnnouncement`;

export const Count = styled.span`
  font-size: 19px;
  font-weight: 700;
  color: #333;
  display: block;
`;

Count.className = `${ROOT}/Count`;

export const Bold = styled.strong`
  color: #000;
`;

Bold.className = `${ROOT}/Bold`;

export const Newspaper = styled.span``;

Newspaper.className = `${ROOT}/Newspaper`;

export const Extracharge = styled.div`
  flex: 0 0 50%;
  width: 50%;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

Extracharge.className = `${ROOT}/Extracharge`;

export const CountExtracharge = styled.p``;

CountExtracharge.className = `${ROOT}/CountExtracharge`;

export const ActionContent = styled.div`
  text-align: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: flex;
    align-items: center;
    flex: 0 0 220px;
    width: 220px;
  }
`;

ActionContent.className = `${ROOT}/ActionContent`;

export const DateExpiration = styled.p`
  margin-top: 20px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 0 20px 0 0;
  }
`;

DateExpiration.className = `${ROOT}/DateExpiration`;

export const TextRed = styled.span`
  color: ${COLORS.RED_HIGHLIGHT};
`;

TextRed.className = `${ROOT}/TextRed`;

export const ButtonPublish = styled.button`
  border-radius: 6px;
  line-height: 36px;
  background: ${COLORS.BLUE_LINK};
  color: #fff;
  text-align: center;
  margin: 30px auto 23px;
  width: 240px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 68px;
  }
`;

ButtonPublish.className = `${ROOT}/ButtonPublish`;
